/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Mini_NInputs */

const en_tut_mini_n = /** @type {(inputs: Tut_Mini_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini only observes: it does not enter the office for you, does not start media, and closing it does not take you out of the office. Microphone and camera controls appear only in the floating window, and even then they only steer a connection already running in the main window. If your browser blocks the pop-up, use the **Buka tampilan ringkas** link.`)
};

const id_tut_mini_n = /** @type {(inputs: Tut_Mini_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini hanya mengamati: ia tidak membuat Anda masuk kantor, tidak menyalakan media, dan menutupnya tidak mengeluarkan Anda dari kantor. Kontrol mikrofon dan kamera hanya muncul pada jendela mengambang, dan itu pun hanya mengatur koneksi yang sudah berjalan di jendela utama. Kalau pop-up diblokir browser, pakai tautan **Buka tampilan ringkas**.`)
};

/**
* | output |
* | --- |
* | "Mini only observes: it does not enter the office for you, does not start media, and closing it does not take you out of the office. Microphone and camera con..." |
*
* @param {Tut_Mini_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_mini_n = /** @type {((inputs?: Tut_Mini_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Mini_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_mini_n(inputs)
	return en_tut_mini_n(inputs)
});